import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['modal']

  toggle() {
    const modalController = this.application.getControllerForElementAndIdentifier(this.modalTarget, 'modal')
    modalController.toggle()
  }
}
